import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Input, Button } from "reactstrap";
import { GetAreaPropertyCount, AreaPropertyCountUpdate } from "service/api"; // renamed for clarity
const PropertyTable = () => {
  const [areaPropertyCounts, setAreaPropertyCounts] = useState([]);
  const [error, setError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 10;

  // Fetch data on mount
  const fetchPropertyCount = async () => {
    try {
      const response = await GetAreaPropertyCount();
      if (response?.properties_count) {
        setAreaPropertyCounts(response.properties_count);
      } else {
        setError("Property count data not found.");
      }
    } catch (err) {
      setError("Error fetching property count data.");
      console.error(err);
    }
  };
  useEffect(() => {
    fetchPropertyCount();
  }, []);


  const filteredData = areaPropertyCounts.filter(item =>
    item.area?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalResults = filteredData.length;
  const totalPages = Math.ceil(totalResults / resultsPerPage);
  const startIndex = (currentPage - 1) * resultsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + resultsPerPage);

  const goToPage = (page) => {
    if (page < 1) page = 1;
    else if (page > totalPages) page = totalPages;
    setCurrentPage(page);
  };


  const phoneNumber = "+919586363303";

  // Function to generate the WhatsApp URL with the current page URL
  const generateWhatsAppLink = () => {
    const currentPageURL = window.location.href; // Get the current page URL
    const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  return (
    <Container fluid style={{ padding: "2rem 1rem" }}>
      <Row className="justify-content-center">
        <Col xs={12}>
          <Card
            style={{
              background: "linear-gradient(to right, #1f2937, #111827)",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)",
              color: "white",
              marginTop: "10%"
            }}
          >
            <CardBody style={{ padding: "2rem" }}>
              <h3 style={{ textAlign: "center", marginBottom: "1.5rem", fontWeight: "600" }}>
                Vadodara Daily Property Updates
              </h3>

              <div style={{ marginBottom: "1.5rem" }}>
                <Input
                  type="text"
                  placeholder="Search by Area..."
                  value={searchTerm}
                  onChange={e => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1); // reset to first page on search change
                  }}
                  style={{
                    padding: "0.75rem 1rem",
                    borderRadius: "50px",
                    border: "1px solid #6b7280",
                    backgroundColor: "#111827",
                    color: "white",
                    fontSize: "1rem",
                    boxShadow: "inset 0 0 5px rgba(0,0,0,0.3)"
                  }}
                />
              </div>

              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    minWidth: "800px",
                    borderCollapse: "collapse"
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#4b5563" }}>
                      <th rowSpan="2" style={headerStyle}>
                        Area
                      </th>
                      <th colSpan="2" style={headerStyle}>
                        Buyers
                      </th>
                      <th colSpan="2" style={headerStyle}>
                        Sellers
                      </th>
                      <th colSpan="2" style={headerStyle}>
                        Owners
                      </th>
                      <th colSpan="2" style={headerStyle}>
                        Tenant/Lease
                      </th>
                    </tr>
                    <tr style={{ backgroundColor: "#374151" }}>
                      <th style={headerStyle}>Commercial</th>
                      <th style={headerStyle}>Residential</th>
                      <th style={headerStyle}>Commercial</th>
                      <th style={headerStyle}>Residential</th>
                      <th style={headerStyle}>Commercial</th>
                      <th style={headerStyle}>Residential</th>
                      <th style={headerStyle}>Commercial</th>
                      <th style={headerStyle}>Residential</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((row, i) => (
                        <tr
                          key={row.id}
                          style={i % 2 === 0 ? rowStyleEven : rowStyleOdd}
                        >
                          <td style={cellStyle}>{row.area}</td>
                          <td style={cellStyle}>{row.buy_com ?? "-"}</td>
                          <td style={cellStyle}>{row.buy_res ?? "-"}</td>
                          <td style={cellStyle}>{row.rent_com ?? "-"}</td>
                          <td style={cellStyle}>{row.rent_res ?? "-"}</td>
                          <td style={cellStyle}>{row.owners_com ?? "-"}</td>
                          <td style={cellStyle}>{row.owners_res ?? "-"}</td>
                          <td style={cellStyle}>{row.lease_com ?? "-"}</td>
                          <td style={cellStyle}>{row.lease_res ?? "-"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" style={{ ...cellStyle, textAlign: "center", fontStyle: "italic" }}>
                          No matching areas found.
                        </td>
                      </tr>
                    )}

                  </tbody>
                </table>
              </div>

              {/* Pagination Controls */}
              <div
                style={{
                  marginTop: "1.5rem",
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  alignItems: "center",
                  color: "white"
                }}
              >
                <Button
                  color="secondary"
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  size="sm"
                >
                  Previous
                </Button>

                <span>
                  Page {currentPage} of {totalPages}
                </span>

                <Button
                  color="secondary"
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                  size="sm"
                >
                  Next
                </Button>
              </div>

              <div
                style={{
                  marginTop: "1.5rem",
                  textAlign: "center",
                  fontSize: "0.85rem",
                  color: "#d1d5db"
                }}
              >
                <p style={{ margin: 0 }}>
                  Last updated: {(() => {
                    const date = new Date();
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}-${month}-${year}`;
                  })()}
                </p>

                <p style={{ margin: "0.5rem 0 0" }}>Note: Numbers represent available properties</p>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        {/* Icons Container */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "12px",
            gap: "10px", // Reduced gap for a more compact design
          }}
        >
          {/* WhatsApp Icon */}
          <a
            href={generateWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "white",
              fontSize: "1.2rem", // Reduced font size
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "40px", // Reduced icon size
              height: "40px",
              background: "linear-gradient(135deg, #1FAF51, #25D366)", // Slightly adjusted green gradient
              borderRadius: "50%",
              boxShadow: "0px 3px 10px rgba(31, 175, 81, 0.6)",
              transition: "all 0.3s ease",
            }}
            title="Chat on WhatsApp"
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.1)";
              e.target.style.boxShadow = "0px 5px 15px rgba(31, 175, 81, 0.8)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "0px 3px 10px rgba(31, 175, 81, 0.6)";
            }}
          >
            <FaWhatsapp />
          </a>

          {/* Call Icon */}
          <a
            href="tel:+919586363303"
            style={{
              color: "white",
              fontSize: "1.2rem", // Reduced font size
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "40px", // Reduced icon size
              height: "40px",
              background: "linear-gradient(135deg, #1E90FF, #34B7F1)", // Slightly adjusted blue gradient
              borderRadius: "50%",
              boxShadow: "0px 3px 10px rgba(30, 144, 255, 0.6)",
              transition: "all 0.3s ease",
            }}
            title="Call Us"
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.1)";
              e.target.style.boxShadow = "0px 5px 15px rgba(30, 144, 255, 0.8)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.boxShadow = "0px 3px 10px rgba(30, 144, 255, 0.6)";
            }}
          >
            <i className="fas fa-phone" />
          </a>
        </div>

        {/* Query Button */}
        <Link
          to="/dashboard"
          title="Any Questions or Queries?"
          style={{
            background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient effect for the button
            border: "none",
            borderRadius: "9999px",
            padding: "10px 20px", // Adjusted padding
            fontSize: "14px", // Reduced font size
            color: "white",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "scale(1.1)";
            e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "scale(1)";
            e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.3)";
          }}
        >
          Ask Ai &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
        </Link>
      </div>
    </Container>


  );
};

// Reusable styles
const headerStyle = {
  padding: "0.75rem",
  textAlign: "center",
  fontWeight: "600",
  fontSize: "0.9rem",
  border: "1px solid #6b7280",
  color: "white",
  whiteSpace: "nowrap"
};

const cellStyle = {
  padding: "0.75rem",
  textAlign: "center",
  fontWeight: "500",
  color: "white",
  border: "1px solid #4b5563"
};

const rowStyleEven = {
  backgroundColor: "#1f2937"
};

const rowStyleOdd = {
  backgroundColor: "#111827"
};

export default PropertyTable;
